export const clothingItems = [
    '60452GG',
    '60452G',
    '60450G',
    '60450GG',
    '9702923VW000L',
    '9702923VW000S',
    '9702923VW002L',
    '9800321VM022L',
    '9817921VM000L',
    '9817921VM000M',
    '9817921VM000S',
    '9815721VM000M',
    '9815721VM002L',
    '9800321VM000S',
    '9800321VM002L',
    '9800321VM000M',
    '9812622VM000M',
    '9812622VM002L',
    '9715023VW002S',
    '9715023VW000L',
    '9800623VW000S',
    '9701122VW002L',
    '9800521VM000L',
    '9800521VM000M',
    '9800521VM000S',
    '9800521VM002L',
    '9812922VM000M',
    '9812922VM002L',
    '9800821VW000M',
    '9812223VM000L',
    '9812223VM000M',
    '9812223VM002L',
    '9804519VM000L',
    '9804519VM000M',
    '9804519VM000S',
    '9818322VW000L',
    '9818322VW000M',
    '9818322VW000S',
    '9812223VM000S',
    '9807414VM000S',
    '9805319VM000L',
    '9805319VM000S',
    '9801321VW000S',
    '9800321VM000L',
    '9806619VW000M',
    '9839119VM000S',
    '9839119VM002L',
    '9815920VW000L',
    '9815920VW000M',
    '9815920VW002S',
    '9813022VM000L',
    '9813022VM000M',
    '9813022VM000S',
    '9813022VM002L',
    '9813122VM000L',
    '9813122VM000M',
    '9813122VM000S',
    '9813122VM002L',
    '9813417VW002L',
    '9818122VW000S',
    '9818122VW002S',
    '9818122VW000L',
    '9703522VM000S',
    '9703522VM002L',
    '9816018VM000S',
    '9701323VM000M',
    '9701323VM000S',
    '9701323VM000L',
    '9701323VM002L',
    '9816518VW000L',
    '9816518VW000M',
    '9816420VW000L',
    '9816420VW000M',
    '9816420VW000S',
    '9817517VM000L',
    '9711422VM000S',
    '9711422VM002L',
    '9744423VW000M',
    '9744423VW002S',
    '9715322VM000S',
    '9715322VM000M',
    '9715322VM002L',
    '9744423VW000L',
    '9744423VW002L',
    '9816518VW000S',
    '9742223VM000M',
    '9742223VM000S',
    '9742223VM000L',
    '9742223VM002L',
    '9816521VM000M',
    '9811621VM000L',
    '9811621VM002L',
    '9810521VM000L',
    '9815521VM000L',
    '9815521VM000M',
    '9811216VM000L',
    '9816821VW000L',
    '9816821VW000M',
    '9816821VW000S',
    '9816821VW002S',
    '9807819VM000S',
    '9828719VW000L',
    '9828719VW000S',
    '9828719VW002S',
    '9742023VM000M',
    '9742023VM000L',
    '9742023VM000S',
    '9742023VM002L',
    '9742123VM002L',
    '9742123VM000S',
    '9811116VM000M',
    '9742422VW000L',
    '9742422VW000M',
    '9742422VW002L',
    '9807114VW000M',
    '9807114VW000L',
    '9807114VW000S',
    '9807114VW002S',
    '9815421VW000L',
    '9815421VW000S',
    '9855714VW002L',
    '9742423VW000S',
    '9742423VW002S',
    '9801418VW002S',
    '9809015VM000L',
    '9809015VM000M',
    '9809015VM002L',
    '9635723VM000L',
    '9635723VM000S',
    '9902823VM000L',
    '9902823VM002L',
    '9904023VW002S',
    '9909022VM000L',
    '9909122VM000L',
    '9909122VM000M',
    '9840122VM000L',
    '9840122VM000M',
    '9840122VM000S',
    '9840122VM022L',
    '9840422VM000M',
    '9833615VM000M',
    '9833615VM000S',
    '9833615VM002L',
    '9667722VW000L',
    '9816221VM000L',
    '9812422VX000L',
    '9812422VX000M',
    '9902823VM000M',
    '9902823VM000S',
    '9904023VW000M',
    '9909022VM000M',
    '9816321VM000M',
    '9816321VM002L',
    '9651823VM000S',
    '9659322VW000S',
    '9742222VW000M',
    '9840820VM000L',
    '9840820VM000M',
    '9840820VM000S',
    '9840820VM002L',
    '9742522VW000L',
    '9742522VW000S',
    '9742522VW002S',
    '9740822VM000S',
    '9740822VM002L',
    '9812422VX002L',
    '9741222VW000L',
    '9741222VW000M',
    '9741222VW000S',
    '9741122VW000S',
    '9741122VW002L',
    '9741122VW002S',
    '9742722VM000L',
    '9742722VM000M',
    '9742722VM000S',
    '9742722VM002L',
    '9742722VM022L',
    '9802418VM000L',
    '9802418VM000S',
    '9802418VM002L',
    '9802418VM022L',
    '9742922VM000S',
    '9667622VW000S',
    '9667622VW002S',
    '9741622VM000S',
    '9742822VM000S',
    '9742822VM002L',
    '9741422VM000S',
    '9741422VM002L',
    '9741522VM000L',
    '9741522VM002L',
    '9627723VW000L',
    '9627723VW000M',
    '9627723VW000S',
    '9627723VW002S',
    '9665623VM000M',
    '9659022VM000S',
    '9640323VW000M',
    '9640323VW000S',
    '9640323VW002S',
    '9630723VM000L',
    '9630723VM000M',
    '9630723VM000S',
    '9642122VW000L',
    '9642122VW000M',
    '9642122VW002S',
    '9900923VW000M',
    '9900923VW000S',
    '9903922VM000S',
    '9903922VM002L',
    '9911822VM000M',
    '9912422VM000L',
    '9912422VM000M',
    '9912422VM002L',
    '9911822VM000L',
    '9911822VM002L',
    '9625622VW000L',
    '9908420VM000M',
    '9640823VW000L',
    '9640823VW000M',
    '9640823VW000S',
    '9640823VW002S',
    '9640923VW000S',
    '9640923VW002S',
    '9628122VM000L',
    '9628122VM000S',
    '9649922VM000M',
    '9649922VM000S',
    '9649922VM002L',
    '9629222VM000S',
    '9629222VM002L',
    '9916619VM000S',
    '9912322VM000M',
    '9912322VM000L',
    '9912322VM000S',
    '9912322VM002L',
    '9650122VM002L',
    '9650122VM000M',
    '9650122VM000S',
    '9628822VM002L',
    '9628722VM002L',
    '9650622VM002L',
    '9658722VM000L',
    '9658722VM000M',
    '9658722VM000S',
    '9658722VM002L',
    '9659722VW000M',
    '9659722VW002S',
    '9659522VW000S',
    '9639523VW000M',
    '9639523VW000S',
    '9639523VW002S',
    '9656322VM000L',
    '9656322VM000M',
    '9629122VM000L',
    '9629122VM002L',
    '9628922VM000S',
    '9628922VM002L',
    '9656822VM002L',
    '9663223VM002L',
    '9909022VM002L',
    '9638822VM000L',
    '9638822VM000M',
    '9647423VW000S',
    '9647423VW002S',
    '9636823VM000S',
    '9904622VM000L',
    '9904622VM000M',
    '9904622VM000S',
    '9904622VM002L',
    '9612123VM000M',
    '9636823VM000M',
    '9636523VM000L',
    '9636523VM000M',
    '9636823VM000L',
    '9636823VM002L',
    '9636823VM022L',
    '9641423VW000S',
    '9641423VW002S',
    '9627923VW000L',
    '9627923VW000M',
    '9627923VW000S',
    '9627923VW002S',
    '9667222VW000L',
    '9667222VW000M',
    '9667222VW000S',
    '9667222VW002S',
    '9632723VM000M',
    '9632723VM000L',
    '9632723VM000S',
    '9907021VM000L',
    '9907021VM002L',
    '9657822VM000L',
    '9657822VM000M',
    '9657822VM002L',
    '9657822VM000S',
    '9621022VW000L',
    '9636523VM002L',
    '9638823VM000L',
    '9638823VM000M',
    '9638823VM002L',
    '9668323VW000L',
    '9668323VW000M',
    '9668323VW000S',
    '9668323VW002L',
    '9668323VW002S',
    '9905521VW000M',
    '9905521VW000S',
    '9637522VM022L',
    '9916619VM002L',
    '9908020VM000S',
    '9908020VM002L',
    '9637922VM000M',
    '9658822VM002L',
    '9658822VM000S',
    '9656922VM000M',
    '9656922VM002L',
    '9658122VM000L',
    '9658122VM002L',
    '9667122VW000M',
    '9667122VW002S',
    '9667122VW000L',
    '9667122VW000S',
    '9637422VM002L',
    '9658022VM000M',
    '9658022VM000S',
    '9658022VM000L',
    '9658022VM002L',
    '9637522VM002L',
    '9666622VW000S',
    '9666622VW002S',
    '9656923VM000L',
    '9656923VM000M',
    '9656923VM000S',
    '9656923VM002L',
    '9619522VM000M',
    '9605722VM000M',
    '9605722VM000S',
    '9605722VM002L',
    '9608922VW000M',
    '9608922VW000S',
    '9656622VM000M',
    '9656622VM002L',
    '9656622VM000S',
    '9656722VM000S',
    '9656722VM002L',
    '9657422VM000L',
    '9657422VM000M',
    '9657422VM002L',
    '9657522VM000L',
    '9657522VM000S',
    '9657722VM000M',
    '9658422VM000M',
    '9637722VM000L',
    '9654722VM000M',
    '9654722VM000S',
    '9654722VM002L',
    '9651422VM000L',
    '9651422VM000M',
    '9651422VM002L',
    '9657222VM002L',
    '9657222VM000L',
    '9657222VM000M',
    '9657222VM000S',
    '9625922VM002L',
    '9902721VM000S',
    '9745523VW002S',
    '9605822VM002L',
    '9632122VM000L',
    '9632122VM002L',
    '9657022VM000L',
    '9657022VM000M',
    '9657022VM000S',
    '9657022VM002L',
    '9658322VM002L',
    '9638422VM000L',
    '9638422VM000M',
    '9638422VM002L',
    '9908320VM000L',
    '9908320VM000M',
    '9666422VW000L',
    '9666422VW000M',
    '9666422VW000S',
    '9666422VW002S',
    '9637322VM000S',
    '9637322VM002L',
    '9651822VM000L',
    '9651822VM000M',
    '9651822VM000S',
    '9651822VM002L',
    '9633822VM000L',
    '9633822VM000S',
    '9633822VM002L',
    '9651922VM000L',
    '9651922VM000M',
    '9651922VM002L',
    '9624322VW000S',
    '9631623VM000S',
    '9631623VM000L',
    '9631623VM000M',
    '9631623VM002L',
    '9644823VW000M',
    '9644823VW000S',
    '9644823VW002S',
    '9644923VW000M',
    '9644923VW000S',
    '9644923VW002S',
    '9602022VM000L',
    '9602022VM002L',
    '9635022VM000L',
    '9635022VM000M',
    '9909820VM022L',
    '9909114VM',
    '9620523VW000L',
    '9620523VW000M',
    '9620523VW000S',
    '9620523VW002S',
    '9906321VM002L',
    '9654422VM000L',
    '9654422VM000M',
    '9654422VM000S',
    '9654422VM002L',
    '9654522VM000L',
    '9654522VM000M',
    '9654522VM000S',
    '9669923VW000L',
    '9669923VW000M',
    '9669923VW000S',
    '9669923VW002L',
    '9669923VW002S',
    '9913122VM000M',
    '9913122VM000L',
    '9913122VM002L',
    '9913722VM002L',
    '9913722VM000M',
    '9633022VM000S',
    '9655122VM000S',
    '9655122VM002L',
    '9655122VM000M',
    '9630622VM000S',
    '9630522VM000L',
    '9630522VM000S',
    '9630722VM000S',
    '9630722VM002L',
    '9630722VM000L',
    '9634922VM000M',
    '9634922VM002L',
    '9644522VW002S',
    '9644522VW000S',
    '9623223VW000L',
    '9620623VW000M',
    '9620623VW000S',
    '9620623VW002S',
    '9623223VW000M',
    '9623223VW000S',
    '9623223VW002S',
    '9644423VW000L',
    '9644423VW000M',
    '9644423VW000S',
    '9644423VW002S',
    '9655722VM000L',
    '9655722VM002L',
    '9655722VM000M',
    '9655722VM000S',
    '9631122VM000S',
    '9651022VM000L',
    '9651022VM000M',
    '9651022VM002L',
    '9656022VM000S',
    '9656022VM002L',
    '9656022VM000L',
    '9656122VM000L',
    '9656122VM000M',
    '9656122VM000S',
    '9656122VM002L',
    '9650822VM000M',
    '9650822VM000L',
    '9650822VM000S',
    '9650822VM002L',
    '9654022VM000L',
    '9654022VM002L',
    '9632722VM000L',
    '9632722VM002L',
    '9632722VM000S',
    '9632922VM000L',
    '9632922VM002L',
    '9632822VM000S',
    '9606423VM000M',
    '9606423VM000L',
    '9606423VM000S',
    '9606423VM022L',
    '9606423VM002L',
    '9606523VM000M',
    '9606523VM000S',
    '9606523VM002L',
    '9606523VM022L',
    '9621123VW000M',
    '9621123VW000S',
    '9621123VW002S',
    '9653522VM000S',
    '9653522VM000L',
    '9653522VM000M',
    '9653522VM002L',
    '9653622VM000L',
    '9653622VM000M',
    '9643022VW000M',
    '9643022VW000S',
    '9643022VW002S',
    '9653322VM000S',
    '9653322VM002L',
    '9653622VM000S',
    '9653622VM002L',
    '9631022VM000S',
    '9653722VM000S',
    '9653722VM000L',
    '9653722VM000M',
    '9653722VM002L',
    '9654122VM000L',
    '9654122VM000S',
    '9654122VM002L',
    '9654122VM000M',
    '9914022VM022L',
    '9662922VW000M',
    '9662822VW000M',
    '9662822VW002S',
    '9662822VW000S',
    '9618522VM002L',
    '9662122VW000M',
    '9662122VW000L',
    '9662122VW000S',
    '9662122VW002S',
    '9655922VM000S',
    '9655822VM000L',
    '9645022VW000M',
    '9651322VM000S',
    '9651322VM002L',
    '9652822VM000L',
    '9652822VM000M',
    '9652822VM000S',
    '9655822VM002L',
    '9655922VM002L',
    '9664022VW000L',
    '9664022VW000M',
    '9645022VW000L',
    '9650722VM000M',
    '9650722VM000S',
    '9650722VM002L',
    '9651322VM000M',
    '9652922VM000L',
    '9652922VM000M',
    '9652922VM002L',
    '9653422VM000M',
    '9655822VM000M',
    '9655922VM000L',
    '9661622VW000M',
    '9661622VW000S',
    '9661622VW002S',
    '9664022VW000S',
    '9664022VW002S',
    '9664722VW000L',
    '9664722VW000M',
    '9664722VW000S',
    '9664722VW002S',
    '9645122VW000S',
    '9645122VW000L',
    '9645122VW000M',
    '9645122VW002S',
    '9654322VM000S',
    '9654322VM022L',
    '9654322VM000L',
    '9654322VM002L',
    '9654322VM000M',
    '9630922VM002L',
    '9630922VM022L',
    '9630822VM000S',
    '9630822VM002L',
    '9664122VW000L',
    '9664122VW002S',
    '9664122VW000M',
    '9664122VW000S',
    '9651222VM000L',
    '9651222VM000M',
    '9651222VM000S',
    '9651222VM002L',
    '9606323VM000M',
    '9606323VM000L',
    '9606323VM000S',
    '9606323VM002L',
    '9609421VW000L',
    '9609923VM000L',
    '9609923VM000M',
    '9609923VM000S',
    '9609923VM002L',
    '9611523VM000M',
    '9611523VM000S',
    '9611523VM002L',
    '9611523VM022L',
    '9643722VW000L',
    '9643123VW000S',
    '9643123VW002S',
    '9643123VW000L',
    '9643123VW000M',
    '9601222VM002L',
    '9601222VM000S',
    '9622822VW000S',
    '9611323VM000L',
    '9611323VM000M',
    '9610923VM000M',
    '9611223VM000M',
    '9611523VM000L',
    '9606623VM000M',
    '9606623VM000S',
    '9606623VM002L',
    '9610923VM000L',
    '9610923VM002L',
    '9610923VM022L',
    '9611223VM000L',
    '9611223VM002L',
    '9611323VM000S',
    '9611323VM002L',
    '9611323VM022L',
    '9643923VW000M',
    '9643923VW000S',
    '9643923VW002S',
    '9910720VW000S',
    '9912522VM000L',
    '9915122VW002S',
    '9915122VW000M',
    '9914022VM000L',
    '9914022VM000S',
    '9914022VM002L',
    '9914522VM000L',
    '9914522VM002L',
    '9914522VM022L',
    '9915422VW000M',
    '9915422VW000S',
    '9915422VW002S',
    '9912522VM002L',
    '9912522VM022L',
    '9913422VM000S',
    '9910620VW000S',
    '9643122VW000S',
    '9623622VW000S',
    '9623622VW002L',
    '9643122VW000M',
    '9644922VW000L',
    '9653822VM002L',
    '9653822VM000M',
    '9653822VM000L',
    '9653822VM000S',
    '9661422VW000L',
    '9661422VW000M',
    '9661922VW000M',
    '9661922VW000S',
    '9661922VW002S',
    '9661922VW000L',
    '9645822VW000L',
    '9645822VW000S',
    '9645822VW002S',
    '9645922VW002S',
    '9645722VW002S',
    '9646022VW000S',
    '9646022VW002S',
    '9652022VM002L',
    '9652122VM000M',
    '9652122VM000S',
    '9652122VM002L',
    '9664422VW000L',
    '9664422VW000M',
    '9643222VW000L',
    '9643222VW002S',
    '9805319VM002L',
    '9705023VM000L',
    '9705023VM000M',
    '9801121VW000M',
    '9801121VW000S',
    '9801121VW000L',
    '9704323VM000L',
    '9704323VM000M',
    '9704323VM002L',
    '9702723VW000M',
    '9702723VW002S',
    '9702723VW000S',
    '9702723VW000L',
    '9704623VW002S',
    '9704623VW000S',
    '9704623VW000M',
    '9704623VW000L',
    '9703423VM022L',
    '9703423VM002L',
    '9703423VM000L',
    '9703423VM000M',
    '9715023VW000M',
    '9715023VW000S',
    '9718823VM000L',
    '9718823VM000M',
    '9718823VM002L',
    '9812622VM000L',
    '9703923VW000L',
    '9816724VM000L',
    '9816724VM000M',
    '9816724VM002L',
    '9800821VW000L',
    '9800821VW000S',
    '9801321VW002L',
    '9800820VW000M',
    '9800820VW000S',
    '9800820VW000L',
    '9805319VM022L',
    '9810321VM022L',
    '9800721VW000L',
    '9800721VW000S',
    '9800721VW002L',
    '9801221VM000L',
    '9801221VM000M',
    '9703323VM002L',
    '9801221VM000S',
    '9717223VM002L',
    '9800623VW000M',
    '9801321VW000L',
    '9801321VW022L',
    '9810321VM000M',
    '9806619VW000L',
    '9719223VM022L',
    '9810321VM000S',
    '9717423VW000L',
    '9717423VW000S',
    '9717423VW002S',
    '9717423VW000M',
    '9719123VM002L',
    '9719223VM000S',
    '9814423VW000M',
    '9814423VW002L',
    '9719623VM000M',
    '9818022VW000M',
    '9815721VM000S',
    '9823518VM042L',
    '9719223VM000L',
    '9719223VM000M',
    '9719223VM002L',
    '9823518VM000L',
    '9823518VM002L',
    '9715322VM022L',
    '9715322VM052L',
    '9715322VM000L',
    '9719023VM022L',
    '9719023VM000M',
    '9718923VM000L',
    '9718923VM002L',
    '9719023VM000L',
    '9719023VM002L',
    '9722023VW000L',
    '9722023VW000S',
    '9722023VW002S',
    '9814822VM000M',
    '9814822VM002L',
    '9814822VM022L',
    '9813623VM000M',
    '9813623VM222L',
    '9813523VM000M',
    '9813523VM002L',
    '9811323VW000L',
    '9811323VW000S',
    '9811323VW002S',
    '9813622VM000L',
    '9813622VM000M',
    '9813722VM000L',
    '9813722VM002L',
    '9827614VM000L',
    '9827614VM000M',
    '9827614VM002L',
    '9827614VM022L',
    '9827614VM222L',
    '9819022VW000S',
    '9819022VW002S',
    '9819122VW000S',
    '9819122VW000M',
    '9819122VW002S',
    '9811820VM000L',
    '9770123VW000L',
    '9770123VW000M',
    '9770123VW000S',
    '9770123VW002S',
    '9720223VM000L',
    '9720223VM000M',
    '9720223VM002L',
    '9720223VM022L',
    '9812920VW000S',
    '9713322VW000L',
    '9713322VW000S',
    '9830414VM222L',
    '9817021VW002S',
    '9816020VW000S',
    '9816020VW002S',
    '9770423VW002S',
    '9817021VW000L',
    '9817021VW000M',
    '9817021VW000S',
    '9817121VW000M',
    '9817121VW000S',
    '9817121VW002S',
    '9834315VW002S',
    '9719722VW000M',
    '9719722VW000S',
    '9719822VW002S',
    '9719822VW000L',
    '9719822VW000M',
    '9719822VW000S',
    '9813120VW002S',
    '9813120VW000L',
    '9817021VW002L',
    '9837817VM000L',
    '9830414VM000L',
    '9830414VM000M',
    '9830414VM022L',
    '9816921VW000S',
    '9816921VW000M',
    '9810619VM000L',
    '9827814VM000L',
    '9827814VM000M',
    '9827814VM222L',
    '9716922VM000M',
    '9716922VM000S',
    '9716922VM002L',
    '9825013VM000M',
    '9825013VM000L',
    '9833019VW002S',
    '9833019VW000M',
    '9833019VW000S',
    '9825013VM000S',
    '9825013VM002L',
    '9827714VM000L',
    '9827714VM000M',
    '9827714VM002L',
    '9827714VM000S',
    '9827714VM022L',
    '9827714VM222L',
    '9818299VM000M',
    '9818299VM022L',
    '9818299VM002L',
    '9825013VM222L',
    '9855714VW000L',
    '9811116VM022L',
    '9811116VM000S',
    '9817208VM000L',
    '9621424VM000L',
    '9811621VM000S',
    '9744823VW002L',
    '9905723VW000M',
    '9621424VM022L',
    '9855714VW022L',
    '9621424VM002L',
    '9621324VM000L',
    '9840422VM000L',
    '9744923VW000L',
    '9744923VW000S',
    '9621424VM000M',
    '9621324VM002L',
    '9828719VW000M',
    '9621324VM022L',
    '9833615VM022L',
    '76218536413',
    '76218536386',
    '76218536385',
    '76218536384',
    '76218536380',
    '76218536379',
    '76218536378',
    '76217922681',
    '76217922675',
    '76217913964',
    '76217913957',
    '76217913956',
    '76211541348',
    '76218536393',
    '76218536392',
    '76218536387',
    '76135A80CC8',
    '76128504858',
    '76617914723',
    '76137913261',
    '76128504857',
    '76137922956',
    '76117913220',
    '76221541335',
    '76228523075',
    '76221541340',
    '80142864303',
    '80145A21690',
    '80142864129',
    '80142864125',
    '80142864122',
    '76618536424',
    '76617109944',
    '76617109852',
    '76617109763',
    '76617109755',
    '76618536687',
    '80142864316',
    '76148568099',
    '76137913262',
    '60435097GG',
    '60435097G',
    '60384097GG',
    '60384097G',
    '60324096P',
    '60324096M',
    '60324075P',
    '60324075M',
    '60324075L',
    '60090M',
    '60377097M',
    'V04010062C002',
    'V04010062C005',
    'V04010062C003',
    'V04010062C001',
    '9949117VM',
    '60455024',
    '60330075',
    '32251582',
    '80162864390',
    '80162864388',
    '76618542488',
    '76617109836',
    '76617109835',
    '76617109834',
    '32251584',
    '32251583',
    '32220654',
    '32220653',
    '32220652',
    '9831614VW000M',
    '80142864285',
    '9819018V',
    '9944910VW',
    '9819118V',
    '9819218V',
    '76237105779',
    '76817921663',
    '80142864291',
    'APR057004MR',
    '60090G',
    '76128504863',
    '76148504911',
    '76617914722',
    '60091GG',
    '76117922941',
    '9761923VM',
    '9774123VM',
    '9761923VM000M',
    '9774123VM000M',
    '41252075G',
    '41252075XG',
    '41271M',
    '7979',
    '134407',
    '41279155G',
    '41280085M',
    '41243052P',
    '41243052M',
    '41242052G',
    '41206275PP',
    '41281075GG',
    '41305075G',
    '41272127XG',
    '41227075G',
    '41289039XG',
    '41289039G',
    '41272127P',
    '41272127M',
    '41305075GG',
    '41304039PP',
    '41272127G',
    '41289039M',
    '41305039XG',
    '41304075GG',
    '41206275M',
    '41304039P',
    '41305075M',
    '41305039GG',
    '41281075G',
    '41272127GG',
    'MTSS2328S',
    'MTPS20533L',
    'MTSS21027L',
    'MTPS20532XL',
    'MCAS2352',
    'MTSS20057L',
    'MTPS20532L',
    'MLTS21310M',
    'MLES23800L',
    'MTSS21028L',
    'MTSS2330S',
    'MTSS2331L',
    'MTPS20532S',
    'MTPS20532M',
    'MLES23800M',
    'MTSS21028M',
    'MTSS2329M',
    'MTSS2331S',
    'MTSS2330L',
    'MTSS21027XL',
    'MLES23800XL',
    '41211024',
    '41101075',
    '9801423VW000L',
    '9801423VW000M',
    '9802418VM000M',
    '9840422VM002L',
    '9816221VM000S',
    '41273141',
    '41223097P',
    '41223097G',
    '41220097M',
    '41286075G',
    '41286075P',
    '41286075M',
    '41277075M',
    '41229075GG',
    '41223097GG',
    '60450GG',
    '60452G',
    '9816221VM022L',
]